/**
 * TanStack Router: file-based routing adapter.
 *
 * The source of truth is `src/routes/*` + generated `src/routeTree.gen.ts`.
 */
import { createRouter } from '@tanstack/react-router';

import type { JoinTransitionPayload } from '~/play/join/continuityTransition';
import { routeTree } from '~/routeTree.gen';

export const router = createRouter({ routeTree });

declare module '@tanstack/history' {
  interface HistoryState {
    joinTransition?: JoinTransitionPayload;
  }
}

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
